import { render, staticRenderFns } from "./ProcessReviewRequestSection.vue?vue&type=template&id=6489ff14&scoped=true"
import script from "./ProcessReviewRequestSection.vue?vue&type=script&lang=js"
export * from "./ProcessReviewRequestSection.vue?vue&type=script&lang=js"
import style0 from "./ProcessReviewRequestSection.vue?vue&type=style&index=0&id=6489ff14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489ff14",
  null
  
)

export default component.exports